import React,{ useEffect, useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../assets/images/CWA_logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, Button, Box, IconButton, Grid , CircularProgress} from "@mui/material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const PaymentReceipt = () => {
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const isPaymentPending = formData?.Payment_Status
    != "Paid";
    const downloadPdf = () => {
      const input = document.getElementById("receipt");
    
      html2canvas(input, {
        scale: 3, // Higher scale for better clarity
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: input.scrollWidth, // Ensuring full width capture
        height: input.scrollHeight, // Ensuring full height capture
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png", 1.0);
        const pdf = new jsPDF("p", "mm", "a4");
    
        const imgWidth = 210; // A4 size width in mm
        const pageHeight = 297; // A4 page height in mm
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
    
        if (imgHeight > pageHeight) {
          let heightLeft = imgHeight;
          let position = 0;
    
          while (heightLeft > 0) {
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            if (heightLeft > 0) {
              pdf.addPage();
              position = -pageHeight;
            }
          }
        } else {
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        }
    
        pdf.save("payment_receipt.pdf");
      });
    };
    
    
  const mobile = localStorage.getItem("mobile");
  console.log("Mobile Number",mobile);

  const fetchUserData = () => {
    const mobile = localStorage.getItem("mobile");
    console.log("Hi");
    if (!mobile) {
        console.error("Mobile number not found in localStorage");
        return;
    }
    axios
        .get(`${API_BASE_URL}?action=myprofile&mobile=${mobile}`)
        .then((response) => {
            if (response.data.status === "success") {
                console.log("Response Date ",response.data.data)
                setFormData(response.data.data);
                console.log("Updated User Data:", response.data.data);
            } else {
                console.error("API error:", response.data.message);
            }
        })
        .catch((error) => console.error("Error fetching data:", error));
};
console.log("PaymentReceipt Component Loaded");



  useEffect(() => {
      console.log("useEffect triggered");
      fetchUserData();
  }, []);

  console.log("Formdata",formData);

  return (

    <div className="max-w-4xl w-full mx-auto border p-6 shadow-lg bg-white min-h-[300px] flex flex-col items-center justify-center">
       {!formData ? (
      <CircularProgress color="success" />
    ) : isPaymentPending ? (
      <Typography variant="body1" color="#7A7841" textAlign="center">
     To download the receipt, please complete your pending payment. {" "}
     <strong>Your current payment status is {formData.Payment_Status}</strong> <br />
      <Typography
          component="span"
          sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
          onClick={() => {
            navigate("/paymentgateway");
            window.scrollTo(0, 0);
        }}
      >
         Click here
      </Typography>{" "}
      to proceed for the payment process. Once the payment is successful, the receipt will be available for download.
  </Typography>
  ) : (<div id="receipt" className="min-h-screen p-6">
        <div className="flex justify-between items-center mb-4">
            <img src={logo} alt="Temple Logo" style={{ width: "140px", height: "auto" }} />
          <div className="text-right text-sm">
            <p>TKS Trust</p>
            <p>Project Office, Chennai</p>
            <p>Phone: +91 98418 18740</p>
            <p>Email: tsct041224@gmail.com</p>
            <p>Website: tkstrust.org</p>
          </div>
        </div>
        <div className="bg-yellow-400 p-2 font-bold text-xl">Payment Receipt</div>
        <div className="text-left mt-4">
          <h2 className="font-bold">Invoice to:</h2>

        
          <p>
            <strong>Name:</strong> {formData.First_Name} {formData.Last_Name}
          </p>
          <p>
            <strong>Address:</strong> {formData.City}
          </p>
          <p>
            <strong>Date:</strong> {formData.Payment_Address}
          </p>
          <p>
            <strong>Payment Method:</strong> <span className="p-1"> {formData.Payment_Method}</span>
          </p>
          <p>
            <strong>Payment ID:</strong> {formData.Payement_id}
          </p>
        </div>
        <hr className="my-4" />
        <h2 className="font-bold mb-2">Products</h2>
        <table className="w-full border text-left">
          <thead>
            <tr className="bg-blue-100">
              <th className="p-2">Product</th>
              <th className="p-2">Validity</th>
              <th className="p-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-blue-50">
              <td className="p-2">Membership</td>
              <td className="p-2">Lifetime</td>

              <td className="p-2">₹ 2000</td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-end mt-4 bg-yellow-400 p-2 font-bold text-lg">
          <span>Total: ₹ 2000</span>
        </div>
        <p className="text-sm text-gray-600 mt-4">
          For any questions, please contact our admin tsct041224@gmail.com or +91 98418 18740.
        </p>
      </div>
      )}
      {isPaymentPending ? (
      <Typography variant="body1" color="#7A7841" textAlign="center">
  </Typography>
  ) :(<div className="flex justify-center mt-6">
        <button
          onClick={downloadPdf}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Download Receipt
        </button>
      </div>)}
      
    </div>
    
  );
};

export default PaymentReceipt;